module.exports = __webpack_public_path__ + "img/works_xikemu_dx_7.9e287576.jpg";